import { clsx } from 'clsx';
import { SmilePlus, Smile, Meh, Frown, Angry } from 'lucide-react';
import { Tooltip } from '@/components/ui/Tooltip';

interface Props {
  sentiment: string;
  showLabel?: boolean;
  size?: 'sm' | 'md';
}

const sentimentConfig: Record<string, { icon: typeof Smile; color: string; label: string }> = {
  very_positive: { icon: SmilePlus, color: 'text-emerald-400', label: 'Very Positive' },
  positive: { icon: Smile, color: 'text-green-400', label: 'Positive' },
  neutral: { icon: Meh, color: 'text-surface-400', label: 'Neutral' },
  negative: { icon: Frown, color: 'text-amber-400', label: 'Negative' },
  very_negative: { icon: Angry, color: 'text-red-400', label: 'Very Negative' },
};

export function SentimentIndicator({ sentiment, showLabel = false, size = 'sm' }: Props) {
  const config = sentimentConfig[sentiment] || sentimentConfig.neutral;
  const Icon = config.icon;

  return (
    <div className="flex items-center gap-1.5">
      <Tooltip content={`Sentiment: ${config.label}`}>
        <Icon
          className={clsx(config.color, {
            'h-4 w-4': size === 'sm',
            'h-5 w-5': size === 'md',
          })}
        />
      </Tooltip>
      {showLabel && <span className={clsx('text-xs', config.color)}>{config.label}</span>}
    </div>
  );
}
